export const actionTypes: any = {
  // get all
  GET_ALL_NABIL_AUCTION_START: 'GET_ALL_NABIL_AUCTION_START',
  GET_ALL_NABIL_AUCTION_SUCCESS: 'GET_ALL_NABIL_AUCTION_SUCCESS',
  GET_ALL_NABIL_AUCTION_FINISH: 'GET_ALL_NABIL_AUCTION_FINISH',

  // get paginated
  GET_NABIL_AUCTION_START: 'GET_NABIL_AUCTION_START',
  GET_NABIL_AUCTION_SUCCESS: 'GET_NABIL_AUCTION_SUCCESS',
  GET_NABIL_AUCTION_FINISH: 'GET_NABIL_AUCTION_FINISH',

  // add
  ADD_NABIL_AUCTION_START: 'ADD_NABIL_AUCTION_START',
  ADD_NABIL_AUCTION_SUCCESS: 'ADD_NABIL_AUCTION_SUCCESS',
  ADD_NABIL_AUCTION_FINISH: 'ADD_NABIL_AUCTION_FINISH',
  RESET_NABIL_AUCTION: 'RESET_NABIL_AUCTION',

  // update
  UPDATE_NABIL_AUCTION_START: 'UPDATE_NABIL_AUCTION_START',
  UPDATE_NABIL_AUCTION_SUCCESS: 'UPDATE_NABIL_AUCTION_SUCCESS',
  UPDATE_NABIL_AUCTION_FINISH: 'UPDATE_NABIL_AUCTION_FINISH',

  // delete
  DELETE_NABIL_AUCTION_START: 'DELETE_NABIL_AUCTION_START',
  DELETE_NABIL_AUCTION_SUCCESS: 'DELETE_NABIL_AUCTION_SUCCESS',
  DELETE_NABIL_AUCTION_FINISH: 'DELETE_NABIL_AUCTION_FINISH',

  // Enable
  ENABLE_NABIL_AUCTION_REQUEST: 'ENABLE_NABIL_AUCTION_REQUEST',
  ENABLE_NABIL_AUCTION_SUCCESS: 'ENABLE_NABIL_AUCTION_SUCCESS',
  ENABLE_NABIL_AUCTION_FINISH: 'ENABLE_NABIL_AUCTION_FINISH',

  // Disable
  DISABLE_NABIL_AUCTION_REQUEST: 'DISABLE_NABIL_AUCTION_REQUEST',
  DISABLE_NABIL_AUCTION_SUCCESS: 'DISABLE_NABIL_AUCTION_SUCCESS',
  DISABLE_NABIL_AUCTION_FINISH: 'DISABLE_NABIL_AUCTION_FINISH',

  // Single Enable
  SINGLE_ENABLE_NABIL_AUCTION_REQUEST: 'SINGLE_ENABLE_NABIL_AUCTION_REQUEST',
  SINGLE_ENABLE_NABIL_AUCTION_SUCCESS: 'SINGLE_ENABLE_NABIL_AUCTION_SUCCESS',
  SINGLE_ENABLE_NABIL_AUCTION_FINISH: 'SINGLE_ENABLE_NABIL_AUCTION_FINISH',

  // Single Disable
  SINGLE_DISABLE_NABIL_AUCTION_REQUEST: 'SINGLE_DISABLE_NABIL_AUCTION_REQUEST',
  SINGLE_DISABLE_NABIL_AUCTION_SUCCESS: 'SINGLE_DISABLE_NABIL_AUCTION_SUCCESS',
  SINGLE_DISABLE_NABIL_AUCTION_FINISH: 'SINGLE_DISABLE_NABIL_AUCTION_FINISH',

  // sort
  SORT_NABIL_AUCTION_START: 'SORT_NABIL_AUCTION_START',
  SORT_NABIL_AUCTION_SUCCESS: 'SORT_NABIL_AUCTION_SUCCESS',
  SORT_NABIL_AUCTION_FINISH: 'SORT_NABIL_AUCTION_FINISH',
  SORT_NABIL_AUCTION_RESET: 'SORT_NABIL_AUCTION_RESET',

  // category list for dropdown
  GET_NABIL_AUCTION_CATEGORY_LIST_START: 'GET_NABIL_AUCTION_CATEGORY_LIST_START',
  GET_NABIL_AUCTION_CATEGORY_LIST_SUCCESS: 'GET_NABIL_AUCTION_CATEGORY_LIST_SUCCESS',
  GET_NABIL_AUCTION_CATEGORY_LIST_FINISH: 'GET_NABIL_AUCTION_CATEGORY_LIST_FINISH',
}
